import React from 'react';

class ArticleCard extends React.PureComponent {
  render() {
    const {article} = this.props;
    return (
      <a className="PostArticleBox EmbedBox EmbedBox--standardMargins" href={article._links.self.href}>
        <div className="SectionTitle">
          <div className="SectionTitle-tab">
            <span className="ShowcaseSectionTitle-label">{article.article_type}</span>
          </div>
          <div className="SectionTitle-sep"></div>
          <div className="SectionTitle-addl"></div>
          <div className="SectionTitle-rest"></div>
        </div>
        <div className="PostArticleBox-subtitle">
          {article.subtitle}
        </div>
        <p>
          {article._links.team.title}
        </p>
        {
          article.picture_url ? (
            <div className="AspectRatioBox AspectRatioBox--ratio-16-9">
              <img src={article.picture_url} />
            </div>
          ): null
        }
        <div className="PostArticleBox-title">{article.title}</div>
        <div className="PostArticleBox-body">
          {
            article.location_str ? (
              <span className="PostArticleBox-location">{article.location_str} &mdash; </span>
            ): null
          }
          {article.first_paragraph}
          <br /><br />
          <div className="text-right color-link">
            Continue reading
          </div>
        </div>
      </a>
    );
  }
}

export default ArticleCard;
